<template>
  <div class="sign_up">
    <div id="head-page" class="inscription parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/montagnes-02.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/sapins-big.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/sapins-small.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="box-double hal white">
      <div class="box-mascotte">
        <img src="@/assets/images/mascotte/mascotte-blind.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
        <div class="box-eye">
          <div class="eye"></div>
        </div>

       <div class="bubble right txtleft" :class="{off: !bubble}">Bonjour, je suis Globulo ! Je suis là pour vous guider dans l’utilisation de cette plateforme et vous tenir compagnie. Et si on commençait par se créer un compte Globulo Quest ?<br>
       Si vous êtes un soignant :  <bouton href="signupCaregiver" class="small">Inscrivez-vous ici</bouton><i class="bt_close fas fa-times-circle" @click="closeBubble"></i></div>
      </div>
    </div>

    <div class="grid-container content-page inscription">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-8 medium-offset-2 large-6 large-offset-3 cell">

          <h3 class="center">Inscrivez-vous :</h3>
          <div class="formulaire inscription" :class="{nobot: !helpBot}" ref="formHolder">
            <div class="switch-form" @click="closeBot"></div>
            <form ref="form">
              <div class="content">

                <div class="box-form">


                  <div class="line" :class="{'error': errors.indexOf('gender') !== -1}">
                    <label for="genre-m">Bonjour je suis Globulo, je suis là pour prendre votre inscription. <br> Qui êtes vous ?</label>
                    <div class="box-radio"><input type="radio" id="genre-m" name="gender" value="H" v-model="gender" ><label for="genre-m">Un homme</label></div>
                    <div class="box-radio"><input type="radio" id="genre-f" name="gender" value="F" v-model="gender" ><label for="genre-f">Une femme</label></div>
                  </div>
                  </br>

                  <div :class="{error: errors.indexOf('firstname') !== -1}">
                    <label for="prenom">Quel est votre prénom ?</label>
                    <input type="text" name="first_name" id="prenom" v-model="first_name" required />
                  </div>

                  <div :class="{error: errors.indexOf('lastname') !== -1}">
                    <label for="nom">Quel est votre nom ?</label>
                    <input type="text" name="last_name" id="nom" v-model="last_name" required />
                  </div>

                  <div :class="{error: errors.indexOf('email') !== -1}">
                    <label for="email">Quel est votre email ?</label>
                    <input type="email" name="email" id="email" v-model="email" required />
                  </div>

                  <div :class="{'error password': errors.indexOf('password') !== -1}">
                    <label for="password">Tapez votre mot de passe :</label>
                    <input type="password" name="password" id="password" v-model="password" required />
                  </div>

                  <div :class="{error: errors.indexOf('password') !== -1, password: errors.indexOf('password') !== -1}">
                    <label for="password-confirm">Confirmez votre mot de passe :</label>
                    <input type="password" name="password_confirmation" id="password-confirm" v-model="password_confirmation" required />
                  </div>

                  <div :class="{'error': errors.indexOf('cgu') !== -1}" cf-questions="J'ai lu et j'accepte <a href='cgu' target='_blank'>les conditions générales d'utilisation.</a>">
                    <input required type="checkbox" id="scales" name="feature" value="scales" v-model="cgu"/>
                    <label for="scales" class="cgu">J'ai lu et j'accepte <a href="cgu" title="conditions générales d'utilisation" target="blank">les conditions générales d'utilisation</a></label>
                  </div>
                  </br>
                  </br>
                  <input class="button btnPush" name="submit" type="submit" value="Valider mon inscription" @click="send" @mouseover="verify" />
                  </br>
                  </br>
                  <p><em>* Champs obligatoires</em></p>
                  <p><em>Pensez à vérifier vos spams une fois l'inscription validée afin de recevoir le mail de confirmation.</em></p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import conversationalForm from 'conversational-form'
  import Bouton from '@/components/Bouton.vue';

  export default {
    data () {
      return {
        gender: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        cgu: false,
        bubble: true,
        helpBot: true,
        errors: []
      }
    },
    components: { Bouton },
    methods: {
      ...mapActions([ 'signup', 'signout']),
      closeBot () {
        this.helpBot = !this.helpBot
      },
      closeBubble () {
        this.bubble = false;
      },
      verify (field) {
        this.errors = []
        if (!this.password || this.password !== this.password_confirmation) {
          this.errors.push("password")
        }
        if (!this.first_name) {
          this.errors.push("firstname")
        }
        if (!this.last_name) {
          this.errors.push("lastname")
        }
        if (!this.email) {
          this.errors.push("email")
        }
        if (!this.gender) {
          this.errors.push("gender")
        }
        if (!this.cgu) {
          this.errors.push("cgu")
        }
      },
      async send (e) {
        e.preventDefault();
        this.verify();
        if (this.errors.length > 0) {
          return false
        }

        try {
          await this.signup({
            email: this.email,
            password: this.password,
            first_name: this.first_name,
            last_name: this.last_name,
            gender: this.gender,
            account_type: 'parent'
          });
          this.$router.push({name: 'PostSignUp'})
        } catch (ex) {
          console.log('error', ex);
        }
      }
    },
    mounted () {
      // this.signout()
      const self = this;

      this.conversation = new conversationalForm({
        formEl: this.$refs.form,
        context: this.$refs.formHolder,
        dictionaryData: {
         	"user-image": "https://cf-4053.kxcdn.com/conversational-form/human.png",
          "entry-not-found": "Dictionary item not found.",
          "awaiting-mic-permission": "Awaiting mic permission",
          "user-audio-reponse-invalid": "I didn't get that, try again.",
          "microphone-terminal-error": "Audio input not supported",
          "input-placeholder": "Entrez votre réponse ici",
          "group-placeholder": "Filtrer la réponse",
          "input-placeholder-error": "Your input is not correct ...",
          "input-placeholder-required": "La réponse est obligatoire",
          "input-placeholder-file-error": "File upload failed ...",
          "input-placeholder-file-size-error": "File size too big ...",
          "input-no-filter": "No results found for <strong>{input-value}</strong>",
          "user-reponse-and": " and ",
          "user-reponse-missing": "Missing input ...",
          "user-reponse-missing-group": "Rien de sélectionné",
          "general": "General type1||General type2",
          "icon-type-file": "<svg class='cf-icon-file' viewBox='0 0 10 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g transform='translate(-756.000000, -549.000000)' fill='#0D83FF'><g transform='translate(736.000000, 127.000000)'><g transform='translate(0.000000, 406.000000)'><polygon points='20 16 26.0030799 16 30 19.99994 30 30 20 30'></polygon></g></g></g></g></svg>",
        },
        dictionaryRobot: {
          "robot-image": "https://cf-4053.kxcdn.com/conversational-form/robot.png",
          "input": "Please write some text.",
          "text": "Please write some text.",
          "checkbox": "Select as many as you want.",
          "name": "What's your name?",
          "email": "Need your e-mail.",
          "password": "Please provide password",
          "tel": "What's your phone number?",
          "radio": "I need you to select one of these.",
          "select": "Choose any of these options.",
          "file": "Select a file to upload.",
          "general": "General1||General2||General3.."
        },
        flowStepCallback (dto, success, error){
          success();
        },
        async submitCallback (conv) {
          const responses = [].reduce.call(
            conv.formEl.elements,
            (stack, { name, value, type, checked = false }) => {
              if (name.slice(-2) === "[]" && value) {
                name = name.slice(0, -2);
                value = (stack[name] || []).concat(value);
              } else if (type === "checkbox") {
                value = checked;
              }

              return Object.assign(stack, { [name]: value });
          }, {});

          try {
            await self.signup({
              email: responses.email,
              password: responses.password,
              first_name: responses.first_name,
              last_name: responses.last_name,
              gender: responses.gender,
              account_type: 'parent'
            });
            self.$router.push({name: 'PostSignUp'})
          } catch (ex) {
            console.log('error', ex);
          }
        }
      });
    }
  }
</script>
